<template>
  <!--
          作者：kmdshop
          时间：2019-10-25
          描述：会员-用户列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="用户">
          <el-input v-model="formInline.search" placeholder="用户ID或者手机号或者昵称或者档案名称"></el-input>
        </el-form-item>




        <el-form-item label="申请时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.create_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>

        <el-form-item label="审核状态">
        <el-select placeholder="请选择审核状态" v-model="formInline.apply_status">
          <el-option label="全部" :value="-1"></el-option>
          <el-option label="未审核" :value="10"></el-option>
          <el-option label="审核通过" :value="20"></el-option>
          <el-option label="审核未通过" :value="30"></el-option>
        </el-select>
      </el-form-item>

        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
          <el-button type="primary" icon="el-icon" @click="reast">重置</el-button>
        </el-form-item>
      </el-form>
    </div>


    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="user_id" label="ID"  width="50" >

          </el-table-column>
          <el-table-column prop="nickName" label="昵称" >
            <template slot-scope="scope">
              <p>{{ scope.row.user.nickName }}</p>

            </template>
          </el-table-column>

          <el-table-column prop="nickName" label="备注" >
            <template slot-scope="scope">
              <p>{{ scope.row.remark }}</p>

            </template>
          </el-table-column>

          <el-table-column prop="nickName" label="当前等级" width="70">
            <template slot-scope="scope">
              <p>{{ scope.row.val.grade_name }}</p>

            </template>
          </el-table-column>

          <el-table-column prop="nickName" label="个人总业绩" width="80">
            <template slot-scope="scope">
              <p>{{ scope.row.val.people_total }}</p>

            </template>
          </el-table-column>

          <el-table-column prop="nickName" label="团队总业绩" width="80">
            <template slot-scope="scope">
              <p>{{ scope.row.val.team_total }}</p>

            </template>
          </el-table-column>

          <el-table-column prop="nickName" label="当月团队业绩" width="260">
            <template slot-scope="scope">
    
              <div >
                <div style="float: left;" >
                  满{{ scope.row.val.price }}元
                </div>

                 <div style="float: right;">当月团队业绩：<span style="color: #ff0000;" 
                  v-if="scope.row.val.current_user_achievement_val >  scope.row.val.price ">
                  {{scope.row.val.current_user_achievement_val}}</span>

                  <span style="color: #00ff55;" 
                  v-if="scope.row.val.current_user_achievement_val <  scope.row.val.price ">
                  {{scope.row.val.current_user_achievement_val}}</span>元</div>
                  <div style="clear: both;"></div>
              </div>

            </template>
          </el-table-column>


          <el-table-column prop="nickName" label="推荐会员" width="180">
            <template slot-scope="scope"> 
              <div v-for="(item,index) in scope.row.val.users" :key="index"  v-if="item.grade_invite_num > 0">
                <div style="float: left;" >
                  推荐{{item.grade_invite_num}}{{item.name}}
                </div>

                 <div style="float: right;">已推荐：{{ item.text_val }}</div>
                  <div style="clear: both;"></div>
              </div>
              
            </template>
          </el-table-column>
      
      
      

          <el-table-column prop="create_time" label="申请时间" width="90"></el-table-column>

          <el-table-column prop="apply_status_text" label="状态" width="80">

        </el-table-column>

          <el-table-column fixed="right" label="操作" width="110">
            <template slot-scope="scope">
              <el-button v-if="scope.row.apply_status == 10" @click="passClick(scope.row)" type="text" 
              size="small"
              
              >通过</el-button>
                <el-button  v-if="scope.row.apply_status == 10" @click="nopassClick(scope.row)" type="text" 
                size="small"
                
                >不通过</el-button>

              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/user/apply/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background :current-page="curPage"
        :page-sizes="[20, 100,500, 1000]"
        layout="total,sizes, prev, pager, next, jumper"
        :total="totalDataNumber"></el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import UserApi from '@/api/user.js';
import qs from 'qs';
export default {
  components: {

  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        search: '',
        create_time: '',
        apply_status:-1,
      },
      /*是否打开添加弹窗*/
      open_add: false,
      open_add1: false,
      /*是否打开批量修改等级弹窗*/
      open_changegrade: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      open_kmd: false,
      open_relation: false,
      /*当前编辑的对象*/
      userModel: {
        // 会员到期时间设置
        expire_date_text: '',
      },
      /*等级*/
      gradeList: [],
      /*选中的*/
      multipleSelection: [],
      /*选择的会员列表*/
      select_list: [],
      app_id: 10001,
      role:[]
    };
  },
  created() {
    if(this.$route.query.user_id && this.$route.query.user_id > 0){
      this.formInline.search = this.$route.query.user_id
    }
    /*获取列表*/
    this.getTableList()
    this.getRole();
  },

  methods: {
    reast(){
        this.curPage = 1
        this.formInline = {
          search: '',
          create_time: '',
          apply_status:-1,
        }
        this.getTableList()
    },
    getRole(){
      let self = this

      let Params = {}

      UserApi.getRole(Params, true)
        .then(data => {
          self.role = data.data
        })
        .catch(error => {

        });
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val
      this.getTableList()
    },
    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.getTableList()
    },

    /*获取列表*/
    getTableList() {
      let self = this
      self.loading = true
      let Params = self.formInline
      Params.page = self.curPage
      Params.list_rows = self.pageSize
      Params.type = 1;
      UserApi.getGradeApply(Params, true)
        .then(data => {
          self.loading = false
          self.tableData = data.data.list.data
          self.totalDataNumber = data.data.list.total
        })
        .catch(error => {
          self.loading = false
        });
    },

    viewUser(user_id){
      this.curPage = 1;;
      this.pageSize = 20;
      this.tableData = [];
      this.formInline.search = user_id;
      this.formInline.agent_id = '';
      this.getTableList();
    },

    viewFirstUser(user_id){
      this.curPage = 1;;
      this.pageSize = 20;
      this.tableData = [];
      this.formInline.search = '';
      this.formInline.agent_id = user_id;
      this.getTableList();
    },

    /*搜索查询*/
    onSubmit() {
      let self = this
      self.curPage = 1
      self.getTableList()
    },

    /*打开添加*/
    addClick(item) {
      this.userModel = item;
      this.open_add = true;
    },

    /*打开添加客户*/
    addClick1() {
      this.open_add1 = true;
    },
    /*打开批量修改等级*/
    ChangeGrade() {
      let user_ids = [];
      let params = this.multipleSelection;
      params.forEach((param) => {
        user_ids.push(param.user_id);
      })
      user_ids = user_ids.join(',');
      console.log(user_ids);
      if (user_ids == '') {
        this.$message({
          message: '请选择修改等级的会员',
          type: 'error'
        });
      } else {
        this.open_changegrade = true;
        this.select_list = user_ids;
      }

    },

    /*关闭添加*/
    closeAdd(e) {
      this.open_add1 = false;
      if (e.type == 'success') {
        this.getTableList();
      }
    },
    /*关闭批量修改等级*/
    closeChangeggrade(e) {
      this.open_changegrade = false;
      if (e.type == 'success') {
        this.getTableList();
      }
    },

    /* 编辑会员信息 */
    editAdd(item) {
      this.userModel = item;
      this.open_kmd = true;
    },
    /*打开编辑*/
    editClick(item) {
      this.userModel = item;
      this.open_edit = true;
    },
    /*选择会员*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },

    /* 修改会员关系 */
    relation(item) {
      this.userModel = item;
      this.open_relation = true;
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'kmd') {
        this.open_kmd = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'relation') {
        this.open_relation = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },

        /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true
          UserApi.deleteGradeApply(
            {
              grade_apply_id: row.grade_apply_id
            },
            true
          )
            .then(data => {
              self.loading = false
              if (data.code == 1) {
                self.$message({
                  message: '删除成功',
                  type: 'success'
                });
                self.getTableList()
              } else {
                self.loading = false
              }
            })
            .catch(error => {
              self.loading = false
            });
        })
        .catch(() => {
          self.loading = false;
        });
    },

    passClick(item){//退款申请-通过审核
      var self = this;
      var Params = {
        grade_apply_id:item.grade_apply_id,
        apply_status:20,
        reject_val:""
      }
      UserApi.auditGradeApply(Params, true)
        .then(data => {
          console.log(data)
          if(data.code == 1){
            self.$message({
                type: 'success',
                message: '审核成功'
            });
              self.getTableList();
              return false;
          }
        })
        .catch(error => {
          
         
        });

    },
    async nopassClick(item){//退款申请-不通过审核
      var self = this;
      const reject_val = await this.promptInput('请输入不通过的原图', '请输入2-4个汉字');
      if(reject_val){
        var Params = {
          grade_apply_id:item.grade_apply_id,
          apply_status:30,
          reject_val:reject_val
        }
        UserApi.auditGradeApply(Params, true)
          .then(data => {
            if(data.code == 1){
              self.$message({
                  type: 'success',
                  message: '审核成功'
              });
                self.getTableList();
                return false;
            }
          })
          .catch(error => {});
      }
  
    },
    async promptInput(message, validation) {
      try {
        const { value } = await this.$prompt(message, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: validation,
        });
        return value.trim();
      } catch(e) {
        this.$message({
          type: 'info',
          message: '取消输入',
        });
        return false;
      }
    },



  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/user/apply/index.vue